module.exports = __webpack_public_path__ + "media/images/lig/uxu-gallery/gallery-item-5-1a0aa0892830fc0d0fbad02f486eb636.jpg";